/**
 * Format link block to url.
 * @param {object} data
 * @returns {string}
 */
export const formatLinkBlockToUrl = (data) => {
    const linkTo = data?.linkTo;
    let url = '';
    switch (linkTo) {
    case 'email':
        url = 'mailto:' + data[linkTo];
        break;
    case 'anchor':
        url = data[linkTo];
        break;
    case 'custom_url':
        url = data?.customUrl;
        break;
    case 'file':
        url = data[linkTo].url;
        break;
    case 'page':
        url = data[linkTo]?.url;
        break;
    case 'phone':
        url = 'tel:' + data[linkTo];
        break;
    }

    return url;
};

export const getBgColor = (backgroundColor) => {
    let bg = '';
    switch (backgroundColor) {
    case 'LIME':
        bg = '#D2FF54';
        break;
    case null :
        bg = '#D2FF54';
        break;
    case undefined :
        bg = '#D2FF54';
        break;
    case 'ORANGE':
        bg = '#FC5200';
        break;
    case 'White':
        bg = '#FFF';
        break;
    case 'Grey':
        bg = '#F7F7F7';
        break;
    }

    return bg;
};
